import React from 'react';
import { 
  Home, 
  Briefcase, 
  Calendar, 
  Settings, 
  Users,
  Phone,
  HelpCircle
} from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';
import { useNavigate, useLocation } from 'react-router-dom';

const MobileFooterNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userProfile } = useAuthStore();
  
  const isAdmin = userProfile?.role === 'admin';
  const isModerator = userProfile?.role === 'moderator';

  const handleNavigation = (href: string) => {
    navigate(href);
  };

  const getCurrentPage = () => {
    const path = location.pathname;
    if (path === '/dashboard') return 'dashboard';
    if (path === '/applications') return 'applications';
    if (path === '/calendar') return 'calendar';
    if (path === '/settings') return 'settings';
    if (path === '/faq') return 'faq';
    if (path === '/moderator/applications') return 'moderator-applications';
    if (path === '/moderator/contacts') return 'moderator-contacts';
    return 'dashboard';
  };

  const currentPage = getCurrentPage();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 sm:hidden">
      <div className="flex justify-around py-1">
        <button
          onClick={() => handleNavigation('/dashboard')}
          className={`flex flex-col items-center p-1 rounded-lg transition-colors ${
            currentPage === 'dashboard' ? 'text-blue-600 bg-blue-50' : 'text-gray-600'
          }`}
        >
          <Home className="w-4 h-4 mb-0.5" />
          <span className="text-xs">Home</span>
        </button>
        
        {isModerator ? (
          <>
            <button
              onClick={() => handleNavigation('/moderator/applications')}
              className={`flex flex-col items-center p-1 rounded-lg transition-colors ${
                currentPage === 'moderator-applications' ? 'text-blue-600 bg-blue-50' : 'text-gray-600'
              }`}
            >
              <Users className="w-4 h-4 mb-0.5" />
              <span className="text-xs">Candidature</span>
            </button>
            <button
              onClick={() => handleNavigation('/moderator/contacts')}
              className={`flex flex-col items-center p-1 rounded-lg transition-colors ${
                currentPage === 'moderator-contacts' ? 'text-blue-600 bg-blue-50' : 'text-gray-600'
              }`}
            >
              <Phone className="w-4 h-4 mb-0.5" />
              <span className="text-xs">Contatti</span>
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => handleNavigation('/applications')}
              className={`flex flex-col items-center p-1 rounded-lg transition-colors ${
                currentPage === 'applications' ? 'text-blue-600 bg-blue-50' : 'text-gray-600'
              }`}
            >
              <Briefcase className="w-4 h-4 mb-0.5" />
              <span className="text-xs">Candidature</span>
            </button>
            <button
              onClick={() => handleNavigation('/calendar')}
              className={`flex flex-col items-center p-1 rounded-lg transition-colors ${
                currentPage === 'calendar' ? 'text-blue-600 bg-blue-50' : 'text-gray-600'
              }`}
            >
              <Calendar className="w-4 h-4 mb-0.5" />
              <span className="text-xs">Colloqui</span>
            </button>
          </>
        )}
        
        <button
          onClick={() => handleNavigation('/faq')}
          className={`flex flex-col items-center p-1 rounded-lg transition-colors ${
            currentPage === 'faq' ? 'text-blue-600 bg-blue-50' : 'text-gray-600'
          }`}
        >
          <HelpCircle className="w-4 h-4 mb-0.5" />
          <span className="text-xs">FAQ</span>
        </button>
        
        <button
          onClick={() => handleNavigation('/settings')}
          className={`flex flex-col items-center p-1 rounded-lg transition-colors ${
            currentPage === 'settings' ? 'text-blue-600 bg-blue-50' : 'text-gray-600'
          }`}
        >
          <Settings className="w-4 h-4 mb-0.5" />
          <span className="text-xs">Impostazioni</span>
        </button>
      </div>
    </div>
  );
};

export default MobileFooterNav; 